var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{directives:[{name:"wms-resource",rawName:"v-wms-resource:text",value:('form-body'),expression:"'form-body'",arg:"text"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }